export default "__VITE_ASSET__Bzsoqffg__"